import { Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CLIENT_ROUTES } from '../../../shared/constants/routes.constants';
import { generatePath } from '../../../shared/services/app.shared-service';
import NotFoundState from '../components/custom/NotFoundState';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useLocale } from '../hooks/useLocale';

const NotFoundPage = () => {
	const { t } = useLocale('client.notFound');

	return (
		<div className="bg-background flex flex-1 items-center justify-center p-4">
			<Card className="w-full max-w-md">
				<CardContent className="flex flex-col items-center gap-6 py-8">
					<NotFoundState
						title={t('pageNotFound')}
						description={t('pageNotFoundDescription')}
						className="border-none bg-transparent p-0"
					/>

					<Button asChild className="mt-2">
						<Link
							to={generatePath({ route: [CLIENT_ROUTES.HOME] })}
						>
							<Home className="w-4 h-4" />
							{t('goHome')}
						</Link>
					</Button>
				</CardContent>
			</Card>
		</div>
	);
};

export default NotFoundPage;
